export const mobileScreenWidth = 768;

export const micrositeIcons = {
    bagError: 'microsite-bag-error',
    bagLoadingAircraft: 'microsite-bag-loading-aircraft',
    bagLoadingDelivered: 'microsite-bag-loading-delivered',
    bagQuestion: 'microsite-bag-question',
    bagSuccess: 'microsite-bag-success',
    noColour: 'microsite-no-colour',
};

export const appLanguageKey = 'appLanguage';
export const appLanguageCountryKey = 'appLanguageCountry';
export const appDefaultLanguage = 'en';
